/**
 * navigation Toggle.
 *
 * Handles toggling the Navigation Menu, Subnavigation Menu and Blurs the Rest away
 */
(function ($) {
    'use strict';

    jQuery(document).ready(function () {
        var navBreakpoint = '(min-width: 1025px)'; // breakpoint is set in scss as well
        var $navToggleElement = $('.js-menu-toggle'); // Burger
        var $templateStateSelector = $('.t-navigation-overlay-state'); // Template Outer Container
        var $subNavToggleElement = $('.m-primary-menu-container .m-navigation__menu-item--has-children > a'); // Sub-Menu Link if has Children
        var $mSearchContainer = $('.m-search-container');

        // Toggle mobile navigation when menu icon (burger) is clicked
        $navToggleElement.on('click', function () {
            $templateStateSelector.toggleClass('t-navigation-overlay-state--open');
        });

        // Function to toggle the Sub Navigation and blur the rest for small screens
        $('.m-navigation__menu-item--has-children a').on('click', $subNavToggleElement, function () {

            $('.t-navigation-overlay-state').removeClass('t-navigation-overlay-state-desktop--open');

            // For large devices: If Search Form is shown close Search Form before open Navigation
            if (!$(this).parents('.m-navigation__sub-menu').attr('class')) {
                if (window.matchMedia(navBreakpoint).matches) {
                    if ($('.m-search-container--active').length) {
                        $(this).parent().toggleClass('m-navigation__menu-item--has-children-desktop--open');
                        $mSearchContainer.removeClass('m-search-container--active');
                        $templateStateSelector.addClass('t-navigation-overlay-state-desktop--open');
                    } else {
                        $('.m-navigation__menu-item--has-children').not($(this).parent()).removeClass('m-navigation__menu-item--has-children-desktop--open');
                        $(this).parent().toggleClass('m-navigation__menu-item--has-children-desktop--open');
                        if ($(this).parent().hasClass('m-navigation__menu-item--has-children-desktop--open')) {
                            $templateStateSelector.addClass('t-navigation-overlay-state-desktop--open');
                        }
                    }
                } else {
                    $(this).parent().toggleClass('m-navigation__menu-item--has-children--open');
                }
                return false;
            }
        });

        // Remove all open Navigation and overlays when click on every Element except the navigationelements
        $('body').on('click', function () {
            $('.m-navigation__menu-item--has-children').removeClass('m-navigation__menu-item--has-children-desktop--open');
            $('.t-navigation-overlay-state').removeClass('t-navigation-overlay-state-desktop--open');
            $mSearchContainer.removeClass('m-search-container--active');
        });

        // Don't remove everything when click on the search form
        $('.m-search-form').on('click', function () {
            event.stopPropagation();
        });
    });

})(jQuery); // This allows us to use '$' in place of 'jQuery' in our code. This is required especially for Wordpress.
